"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Paper_1 = __importDefault(require("@material-ui/core/Paper"));
var Paper = function (_a) {
    var classes = _a.classes, children = _a.children, _b = _a.elevation, elevation = _b === void 0 ? 1 : _b, _c = _a.square, square = _c === void 0 ? false : _c, _d = _a.component, component = _d === void 0 ? 'div' : _d, _e = _a.variant, variant = _e === void 0 ? 'elevation' : _e;
    return (react_1.default.createElement(Paper_1.default, { classes: classes, elevation: elevation, square: square, component: component, variant: variant }, children));
};
exports.default = Paper;
